module.exports = __webpack_public_path__ + "img/HoveredTwitterIcon.7ab5521d.svg";